import { FaHeadset, FaClock, FaShieldAlt, FaTools } from 'react-icons/fa';
import './About.css';

const marks = [
  { icon: FaHeadset, label: 'Live agents' },
  { icon: FaClock, label: '24×7 help' },
  { icon: FaShieldAlt, label: 'Secure help' },
  { icon: FaTools, label: 'Remote fix' },
];

export default function About() {
  return (
    <section className="dh-about" id="about">
      <div className="dh-container dh-about__grid">
        <div className="dh-about__media">
          <img
            src="/images/team.jpg"
            alt="Dragon Help support team collaborating in the office"
            width="640"
            height="520"
          />
        </div>
        <div className="dh-about__copy">
          <h2>Delivering Quality and Customer Service.</h2>
          <p>
            Dragon Help is built for people who rely on voice recognition every day. We focus on clear
            answers, careful microphone and profile setup, and patient walkthroughs when Dragon will not
            start, activate, or recognize speech correctly.
          </p>
          <p>
            Whether you are installing a fresh copy, upgrading an older version, or chasing a stubborn
            error code, our specialists stay with you until dictation is working the way it should —
            without jargon and without unnecessary upsells.
          </p>
          <div className="dh-about__marks" role="list" aria-label="Service strengths">
            {marks.map(({ icon: Icon, label }) => (
              <div className="dh-about__mark" role="listitem" key={label}>
                <Icon aria-hidden />
                <span>{label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
